/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardIcon({
  children,
  viewPath = "/DesignSystem/Svgs/CreditCardIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CreditCardIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-ZqiKMY': alignSelf,'--mt-2-ZqiKMY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZqiKMY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZqiKMY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZqiKMY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZqiKMY': opacity,'--w-10-ZqiKMY': typeof width === 'number' ? `${width}px` : width,'--h-11-ZqiKMY': typeof height === 'number' ? `${height}px` : height,'--a-7-ZqiKMY': isAnimated ? animation : "none",'--sd-8-ZqiKMY': isAnimated ? strokeDashoffset : 0,'--sd-9-ZqiKMY': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CreditCardIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M27.4 25.3H4.6c-1.5 0-2.7-1.2-2.7-2.7V9.4c0-1.5 1.2-2.7 2.7-2.7h22.8c1.5 0 2.7 1.2 2.7 2.7v13.2c0 1.5-1.2 2.7-2.7 2.7zM3.1 19h25.8"
 style={{'--f-12-ZqiKMY': fill,'--s-13-ZqiKMY': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}